import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { EpbtFaQuickPurchaseService } from '../../services/epbt-fa-quick-purchase.service';
import { IEpGridModel, IEpGridSelectionOptions, IEpComponentEventArg } from '@epicor/kinetic';

declare var $: any;

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'epbt-fa-quick-purchase-summary-products-grid',
  templateUrl: './epbt-fa-quick-purchase-summary-products-grid.component.html',
  styleUrls: ['./epbt-fa-quick-purchase-summary-products-grid.component.scss']
})
export class EpbtFaQuickPurchaseSummaryProductsGridComponent implements OnInit {
  webTrackUser: any;
  bisTrackUserId: number;
  public gridModel: IEpGridModel;

  @ViewChild('quantityTemplate', { static: true }) quantityTemplate: TemplateRef<any>;

  constructor(public faQuickPurchaseService: EpbtFaQuickPurchaseService) { }

  ngOnInit() {
    // this.updateGridData();
  }

  getGridModel(): IEpGridModel {
    const selectionOptions: IEpGridSelectionOptions = {
      selectByField: 'productId',
      selectedKeys: [],
    };
    const model: IEpGridModel = {
      resizable: false,
      reorderable: false,
      groupable: false,
      filterable: false,
      scrollable: 'scrollable',
      rowHeight: 20,
      height: this.getHeight(),
      sortable: true,
      selectionOptions: selectionOptions,
      columns: [
        { field: 'productId', title: '', width: 30, hidden: true },
        { field: 'productCode', title: 'CODE', width: 30, hidden: false },
        { field: 'description', title: 'DESCRIPTION', width: 30, hidden: false },
        { field: 'quantity', title: 'QUANTITY', width: 30, hidden: false, cellTemplate: this.quantityTemplate },
        { field: 'uom', title: 'UOM', width: 30, hidden: false },
        { field: 'tallyString', title: 'TALLY', width: 30, hidden: false }
      ],
      epOnComponentEvent: (eventArg: IEpComponentEventArg) => {
        if (eventArg.eventId == 'epOnCellClick' && eventArg.event && eventArg.event.type == 'click') {
        }
      },
    };
    $(window).resize(() => {
      this.updateGrid();
    });
    return model;
  }

  // grid height calculation start
  updateGrid() {
    const calHeight = this.getHeight();
    this.gridModel.height = calHeight;
  }

  getHeight(): number {
    const height = $(window).outerHeight() - 420; // 399
    const width = parseInt($('body').width());

    if (width > 250 && width < 1023) {
      // mobile and ipad
      return 400;
    }
    return height;

  }


  updateGridData() {
    this.gridModel = this.getGridModel();
    if (this.faQuickPurchaseService.selectedProductsForBinding.length > 0) {
      const lines: any[] = [];
      this.faQuickPurchaseService.selectedProductsForBinding.forEach(element => {
        const line: any = {
          productId: element.product.productId,
          productCode: element.product.productCode,
          description: element.product.description,
          quantity: element.quantity,
          uom: element.inputPer ? element.inputPer.perCode : "",
          tallyString: element.tally.tallyString
        };
        lines.push(line);
      });
      this.gridModel.data = lines;
    } else {
      this.gridModel.data = null;
    }
  }
}
